import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/app-shell';
import { RequireAuth } from '@/components/require-auth';
import { AccountPage } from '@/pages/account-page';
import { AccountsPage } from '@/pages/accounts-page';
import { DiscountsPage } from '@/pages/discounts-page';
import { LoginPage } from '@/pages/login-page';
import { ProvisionPage } from '@/pages/provision-page';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route path="/accounts" element={<AccountsPage />} />
            <Route path="/accounts/:id" element={<AccountPage />} />
            <Route path="/provision" element={<ProvisionPage />} />
            <Route path="/discounts" element={<DiscountsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/accounts" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
